import { z } from 'zod'

export const knockdownInputLevelSchema = z.number().nullable()
